import React, { useState, useMemo, useCallback } from "react";
import EditFieldModal from "./EditFieldModal";
import { RiDeleteBin4Fill } from "react-icons/ri";
import { MdEditSquare } from "react-icons/md";
import { FiCopy } from "react-icons/fi"; // Importing the copy icon
import { InputLabel, InputType, SelectBorder } from "../../../../Global/GlobalFormElement";
import { useDispatch, useSelector } from "react-redux";
import { updateFieldPayload } from "../../../../Redux/Users/action";

const FormCanvas = ({ fields, updateField, removeField, disableRequiredCheckbox, addedFields, formSchema, copiedFields, copyField, removeFieldFromCopied, updateAddedField, updateCopiedField,
  handleDragStart, handleDragEnd, handleDrop

}) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentField, setCurrentField] = useState(null);
  const [conditionFieldName, setConditionFieldName] = useState(null);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [fieldType, setFieldType] = useState("");


  const fieldPayload = useSelector((state) => state.field.fieldPayload);

  const dispatch = useDispatch();
  const countries = useMemo(() => [
    "United States", "Canada", "United Kingdom", "Australia", "India",
    "Germany", "France", "Italy", "Spain", "Mexico", "Japan", "South Korea",
    "Brazil", "China", "South Africa", "Russia", "Netherlands", "Sweden",
    "Switzerland", "Belgium"
  ], []);

  const fieldLabels = useMemo(() => fields.map(field => field.label), [fields]);
  const dataNames = useMemo(() => fields.map(field => field.dataName), [fields]);

  const openModal = useCallback((field, type) => {
    setCurrentField(field);
    setFieldType(type);
    let conditionFieldName = null;

    if (field.requiredCondition && field.requiredFieldValue) {
      const conditionField = fields.find(f => f.dataName === field.requiredFieldValue);
      if (conditionField) {
        conditionFieldName = conditionField.dataName;
      }
    }

    if (field.visibleCondition && field.visibleFieldValue) {
      const conditionField = fields.find(f => f.dataName === field.visibleFieldValue);
      if (conditionField) {
        conditionFieldName = conditionField.dataName;
      }
    }

    setIsModalOpen(true);
    setConditionFieldName(conditionFieldName);
  }, [fields]);

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentField(null);
  };

  const handleRequiredChange = (index) => {
    const updatedFields = [...addedFields];
    const field = updatedFields[index];
    const updatedField = {
      ...field,
      required: !field.required,
    };
    updatedFields[index] = updatedField;
    dispatch(updateFieldPayload(field.dataName, { required: updatedField.required }));
    updateAddedField(updatedFields);
  };

  const handleVisibleChange = (index) => {
    const updatedFields = [...addedFields];
    const field = updatedFields[index];
    const updatedField = {
      ...field,
      visible: !field.visible,
    };
    updatedFields[index] = updatedField;
    dispatch(updateFieldPayload(field.dataName, { visible: updatedField.visible }));
    updateAddedField(updatedFields);
  };


  const handleSave = (updatedField) => {
    try {
      const updatedFields = fields.map((field) =>
        field.dataName === updatedField.dataName ? { ...field, ...updatedField } : field
      );
      updateField(updatedFields);
      closeModal();
    } catch (error) {
      console.error("Error saving field:", error);
    }
  };

  const handleFileChange = (e, fieldIndex) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const updatedFields = [...fields];
        updatedFields[fieldIndex].value = file;
        updateField(updatedFields);
      } catch (error) {
        console.error("Error handling file change:", error);
      }
    }
  };

  const handleRequiredToggle = (fieldIndex) => {
    const updatedFields = [...fields];
    const field = updatedFields[fieldIndex];
    if (!field.isDefault) {
      if (field.requiredCondition && field.requiredFieldValue) {
        const conditionField = fields.find(f => f.dataName === field.requiredFieldValue);
        field.isConditionMet = conditionField && conditionField.value === field.requiredFieldValue;
        if (field.isConditionMet) {
          field.required = !field.required;
          updateField(updatedFields);
        } else {
          alert(`${field.label} is required based on the selected condition.`);
        }
      } else {
        field.isConditionMet = true;
        field.required = !field.required;
        updateField(updatedFields);
      }
    }
  };

  const handleVisibleToggle = (fieldIndex) => {
    const updatedFields = [...fields];
    const field = updatedFields[fieldIndex];
    if (field.visibleCondition && field.visibleFieldValue) {
      const conditionField = fields.find(f => f.dataName === field.visibleFieldValue);
      field.isConditionMet = conditionField && conditionField.value === field.visibleFieldValue;
      if (field.isConditionMet) {
        field.visible = !field.visible;
        updateField(updatedFields);
      } else {
        alert(`${field.label} is not visible based on the selected condition.`);
      }
    } else {
      field.isConditionMet = true;
      updateField(updatedFields);
    }
  };



  const validateForm = () => {
    for (let field of fields) {
      if (field.required && field.requiredFieldValue) {
        const conditionField = fields.find(f => f.label === field.requiredFieldValue);
        if (conditionField) {
          const fieldConditionMet = conditionField.value === field.requiredFieldValue;
          if (!fieldConditionMet) {
            alert(`${field.label} is required based on the selected condition.`);
            return false;
          }
        }
      } else if (field.required && field.type !== "file" && !field.value) {
        alert(`${field.label} is required.`);
        return false;
      }
    }
    return true;
  };

  console.log(fields, "asdasdasd")
  console.log(addedFields, "asdddddddd")

  const handleFieldChange = useCallback((index, value) => {
    const updatedFields = [...fields];
    updatedFields[index].value = value;
    updateField(updatedFields);

    const copiedField = updatedFields.find(field => field.dataName === `${updatedFields[index].dataName}_copy`);
    if (copiedField) {
      copiedField.value = value;
      updateField(updatedFields);
    }
  }, [fields, updateField]);


  const TextField = ({ field, index, handleFieldChange }) => (
    <InputType readOnly disabled type="text" placeholder={field.label} value={field.value || ""} onChange={handleChange} />
  );

  const renderField = (field, index, fieldType) => {
    const fieldProps = {
      style: { width: field.fieldSize },
      value: field.value || "",
      onChange: { handleChange },
      ariaLabel: field.label,
      readOnly: true,
      disabled: true,
    };
    switch (field.type) {
      case "text":
        return (
          <TextField
            field={field}
            {...fieldProps}
            type="text"
            index={index}
            handleFieldChange={handleChange}
            fieldType={fieldType}
            placeholder={fieldPayload && fieldPayload.find(item => item.dataName === field.dataName)?.label || field.label}
            name={field.dataName}

          />
        );
      case "label":
        return (
          <div
            field={field}
            {...fieldProps}
            type="label"
            index={index}
            handleFieldChange={handleChange}
            fieldType={fieldType}
            placeholder={fieldPayload && fieldPayload.find(item => item.dataName === field.dataName)?.label || field.label}
            name={field.dataName}

          />
        );
      case "email":
        return (
          <InputType
            type="email"
            placeholder={fieldPayload && fieldPayload.find(item => item.dataName === field.dataName)?.label || field.label}
            {...fieldProps}
            name={field.dataName}
          />
        );

      case "tel":
        return (
          <InputType
            type="tel"
            placeholder={fieldPayload && fieldPayload.find(item => item.dataName === field.dataName)?.label || field.label}
            {...fieldProps}
            name={field.dataName}

          />
        );

      case "date":
        return (
          <InputType
            type="date"
            placeholder={fieldPayload && fieldPayload.find(item => item.dataName === field.dataName)?.label || field.label}
            {...fieldProps}
            name={field.dataName}

          />
        );

      case "textarea":
        return (
          <textarea
            placeholder={fieldPayload && fieldPayload.find(item => item.dataName === field.dataName)?.label || field.label}
            {...fieldProps}
            name={field.dataName}
          />
        );
      case "country":
        return (
          <SelectBorder value={field.value || ""}     {...fieldProps} onChange={(e) => {
            const updatedFields = [...fields];
            updatedFields[index].value = e.target.value;
            updateField(updatedFields);

          }}>
            {countries.map((country, idx) => (
              <option key={idx} value={country}>
                {country}
              </option>
            ))}
          </SelectBorder>
        );
      case "checkbox":
        const findFieldPayload = fieldPayload?.find((item) => item.dataName === field.dataName);
        return (
          <div className="checkboxes">
            {(findFieldPayload ? findFieldPayload.options : addedFields?.find(f => f.dataName === field.dataName)?.options || []).map((option, idx) => (
              <div key={idx} className="input-lbl">
                <input
                  type="checkbox"
                  checked={field.value?.includes(option)}
                  onChange={() => {
                    const updatedFields = [...fields];
                    const fieldIndex = updatedFields.findIndex(f => f.dataName === field.dataName);
                    if (fieldIndex !== -1) {
                      const fieldValue = updatedFields[fieldIndex].value || [];
                      if (fieldValue.includes(option)) {
                        updatedFields[fieldIndex].value = fieldValue.filter((val) => val !== option);
                      } else {
                        updatedFields[fieldIndex].value = [...fieldValue, option];
                      }
                      updateField(updatedFields);
                    }
                  }}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
        );

      case "dropdown":
        const findDropdownPayload = fieldPayload?.find((item) => item.dataName === field.dataName);
        return (
          <SelectBorder value={field.value || ""} {...fieldProps} onChange={(e) => handleChange(e, fieldType)} aria-label={field.label}>
            {(findDropdownPayload ? findDropdownPayload.options : addedFields?.find(f => f.dataName === field.dataName)?.options || []).map((option, idx) => (
              <option key={idx} value={option}>{option}</option>
            ))}
          </SelectBorder>
        );

      case "radio":
        const findRadioPayload = fieldPayload?.find((item) => item.dataName === field.dataName);
        return (
          <div className="radio-btns">
            {(findRadioPayload ? findRadioPayload.options : addedFields?.find(f => f.dataName === field.dataName)?.options || []).map((option, idx) => (
              <div key={idx} className="input-lbl">
                <input
                  type="radio"
                  name={field.dataName}
                  value={option}
                  checked={field.value === option}
                  onChange={(e) => handleChange(e, fieldType)}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
        );


      case "file":
        return <input type="file" onChange={(e) => handleFileChange(e, index)} />;
      default:
        return null;
    }

  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (!name || value === undefined) {
      console.error("Invalid input field or missing name/value");
      return;
    }

    const updatedFields = fields.map((field) => {
      if (field.dataName === name) {
        return { ...field, value };
      }
      return field;
    });

    updateField(updatedFields);
  };



  return (
    <div className="form-canvas">
      {fields.map((field, index) => (
        <div
          key={field.dataName}
          className="field-container"
          draggable
          onDragStart={(e) => handleDragStart(e, index, "fields")}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop(e, index, "fields")}
          onDragEnd={handleDragEnd}
        >
          <div className="field-input-container">
            <InputLabel>
              {field.label}
              {(field.required || field.isRequired) && <span style={{ color: "red" }}> *</span>}
              {field.hoverHint && <span className="hover-hint-icon" title={field.hoverHint}>?</span>}
            </InputLabel>
          </div>
          <div className="form_canvas_type_fields">
            {renderField(field, index)}
          </div>
          <div className="field-options-container">
            <div className="field-actions">
              <MdEditSquare className="form_canvas_icon" onClick={() => openModal(field, "normal")} />
            </div>
            <div className="required_checkbox">
              <label>Required</label>
              <input
                type="checkbox"
                checked={field.required || field.isRequired}
                onChange={(e) => handleChange(e, "default")}
                disabled={disableRequiredCheckbox && field.isDefault}
              />
            </div>
            <div className="visible_checkbox">
              <label>Visible</label>
              <input
                type="checkbox"
                checked={field.visible}
                onChange={() => handleVisibleToggle(index)}
                disabled={field.isDefault}
              />
            </div>
          </div>
        </div>
      ))}



      {addedFields?.map((field, index) => (
        <div
          key={field.dataName}
          className="field-container"
          draggable
          onDragStart={(e) => handleDragStart(e, index, "addedFields")}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop(e, index, "addedFields")}
          onDragEnd={handleDragEnd}
        >
          <div className="field-input-container">
            <InputLabel>
              {fieldPayload && fieldPayload.find(item => item.dataName === field.dataName)?.label || field.label}
              {(field.required || field.isRequired) && <span style={{ color: "red" }}> *</span>}
              {(fieldPayload?.hoverHint || fieldPayload?.find(item => item.dataName === field.dataName)?.hoverHint || field?.hoverHint) && (
                <span
                  className="hover-hint-icon"
                  title={fieldPayload?.find(item => item.dataName === field.dataName)?.hoverHint || field?.hoverHint}
                >
                  ?
                </span>
              )}
            </InputLabel>
          </div>
          <div className="form_canvas_type_fields">
            {renderField(field, index, "added")}
          </div>
          <div className="field-options-container">
            <div className="field-actions">
              <MdEditSquare className="form_canvas_icon" onClick={() => openModal(field, "added")} />
              <RiDeleteBin4Fill className="form_canvas_icon" onClick={() => removeField(index)} />
              <FiCopy className="form_canvas_icon" onClick={() => copyField(index)} />
            </div>
            <div className="required_checkbox">
              <label>Required</label>
              <input
                type="checkbox"
                checked={field.required || field.isRequired || fieldPayload.find(item => item.dataName === field.dataName)?.required}
                disabled
                onChange={() => handleRequiredChange(index)}
              />
            </div>
            <div className="visible_checkbox">
              <label>Visible</label>
              <input
                type="checkbox"
                checked={
                  fieldPayload.find(item => item.dataName === field.dataName)
                    ? fieldPayload.find(item => item.dataName === field.dataName)?.visible
                    : field.visible
                }
                disabled
                onChange={() => handleVisibleChange(index)}
              />
            </div>
          </div>
        </div>
      ))}



      {copiedFields.map((copiedField, index) => (
        <div key={copiedField.dataName} className="field-container"
          draggable
          onDragStart={(e) => handleDragStart(e, index, "copiedFields")}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop(e, index, "copiedFields")}
          onDragEnd={handleDragEnd}
        >
          <div className="field-input-container">
            <InputLabel>
              {copiedField.label}
              {(copiedField.required || copiedField.isRequired) && <span style={{ color: "red" }}> *</span>}
              {(fieldPayload?.hoverHint || fieldPayload?.find(item => item.dataName === copiedField.dataName)?.hoverHint || copiedField?.hoverHint) && (
                <span
                  className="hover-hint-icon"
                  title={fieldPayload?.find(item => item.dataName === copiedField.dataName)?.hoverHint || copiedField?.hoverHint}
                >
                  ?
                </span>
              )}

            </InputLabel>
          </div>
          <div className="form_canvas_type_fields">
            {renderField(copiedField, index)}
          </div>
          <div className="field-options-container">
            <div className="field-actions">
              <MdEditSquare className="form_canvas_icon" onClick={() => openModal(copiedField, "added")} />
              <RiDeleteBin4Fill className="form_canvas_icon" onClick={() => removeFieldFromCopied(index)} />
              <FiCopy className="form_canvas_icon" onClick={() => copyField(index)} />
            </div>
            <div className="required_checkbox">
              <label>Required</label>
              <input
                type="checkbox"
                checked={copiedField.required || copiedField.isRequired}
                onChange={() => handleRequiredToggle(index, "addedFields")}
                disabled
              />
            </div>
            <div className="visible_checkbox">
              <label>Visible</label>
              <input
                type="checkbox"
                checked={
                  fieldPayload.find(item => item.dataName === copiedField.dataName)
                    ? fieldPayload.find(item => item.dataName === copiedField.dataName)?.visible
                    : copiedField.visible
                } onChange={(e) => handleChange(e, "copied")}

                disabled
              />
            </div>
          </div>
        </div>
      ))}


      {isModalOpen && currentField && (
        <EditFieldModal
          field={currentField}
          onSave={handleSave}
          onClose={closeModal}
          fieldType={fieldType}
          fieldLabels={fieldLabels}
          dataNames={dataNames}
          conditionFieldName={conditionFieldName}
          formSchema={formSchema}
          addedFields={addedFields}
          updateAddedField={updateAddedField}
        />
      )}
    </div>
  );
};

export default FormCanvas;
